import { takeEvery } from "redux-saga/effects";
import {
  checkEmailAction,
  codeValidatorAction,
  confirmValidatorAction,
  externalLoginAction,
  forgotPasswordAction,
  loginAction,
  registerAction,
  resetPasswordAction,
} from "./slices";
import {
  checkEmailWorker,
  codeValidatorWorker,
  confirmValidatorWorker,
  externalLoginWorker,
  forgotPasswordWorker,
  loginWorker,
  registerWorker,
  resetPasswordWorker,
} from "./workers";

const authWatcher = [
  takeEvery(checkEmailAction, checkEmailWorker),
  takeEvery(codeValidatorAction, codeValidatorWorker),
  takeEvery(confirmValidatorAction, confirmValidatorWorker),
  takeEvery(registerAction, registerWorker),
  takeEvery(loginAction, loginWorker),
  takeEvery(externalLoginAction, externalLoginWorker),
  takeEvery(forgotPasswordAction, forgotPasswordWorker),
  takeEvery(resetPasswordAction, resetPasswordWorker),
];

export default authWatcher;
